import React, { useState } from 'react';
import Select from 'react-select';
import BookService from '../../services/BookService';

const TeacherClass = ({ teacher, books, students }) => {
  const [selectedBooksForClass, setSelectedBooksForClass] = useState(
    [],
  );
  const [selectedBooksForStudents, setSelectedBooksForStudents] =
    useState({});
  const [isExpanded, setIsExpanded] = useState(false);

  const bookOptions = books.map((book) => ({
    value: book.id,
    label: book.title,
  }));

  const handleStudentBookSelection = (studentId, selectedOptions) => {
    setSelectedBooksForStudents((prev) => ({
      ...prev,
      [studentId]: selectedOptions
        ? selectedOptions.map((o) => o.value)
        : [],
    }));
  };

  const handleNotifyAllStudents = async () => {
    if (selectedBooksForClass.length === 0) {
      alert('Select at least one book.');
      return;
    }
    await BookService.sendBookNotificationToAll(
      selectedBooksForClass,
      teacher.id,
    );
    alert('Sent to all students.');
  };

  const handleNotifyStudent = async (studentId) => {
    const bookIds = selectedBooksForStudents[studentId] || [];
    if (bookIds.length === 0) {
      alert('Select at least one book.');
      return;
    }
    await BookService.sendBookNotification(bookIds, studentId);
    alert('Sent to student.');
  };

  return (
    <div className="bg-white shadow rounded-lg p-4 mb-4">
      {/* Header */}
      <div className="flex items-center justify-between mb-3">
        <h2 className="text-sm md:text-base font-semibold text-gray-800">
          {teacher.firstName} {teacher.lastName}
          <span className="text-gray-500 ml-2">
            ({teacher.classAbbrev})
          </span>
        </h2>

        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className="text-sm bg-cyan-700 text-white px-3 py-1 rounded hover:bg-cyan-800"
        >
          {isExpanded ? 'Hide' : 'Show'}
        </button>
      </div>

      {/* Class Book Selection */}
      <div className="flex flex-col md:flex-row gap-2 mb-3 items-start md:items-center">
        <div className="flex-1 w-full">
          <Select
            isMulti
            options={bookOptions}
            placeholder="Select books for class..."
            onChange={(opts) =>
              setSelectedBooksForClass(
                opts ? opts.map((o) => o.value) : [],
              )
            }
            className="text-sm"
          />
        </div>

        <button
          onClick={handleNotifyAllStudents}
          className="bg-green-600 text-white px-3 py-1.5 text-sm rounded hover:bg-green-700"
        >
          Notify All
        </button>
      </div>

      {/* Students */}
      {isExpanded && (
        <div className="border rounded max-h-72 overflow-y-auto">
          <table className="w-full text-xs md:text-sm">
            <thead className="bg-gray-100 text-gray-700 sticky top-0">
              <tr>
                <th className="px-2 py-1 text-left">Name</th>
                <th className="px-2 py-1 text-left hidden md:table-cell">
                  Email
                </th>
                <th className="px-2 py-1 text-left hidden md:table-cell">
                  Last Sent
                </th>
                <th className="px-2 py-1 text-right">Action</th>
              </tr>
            </thead>

            <tbody>
              {students.map((student) => (
                <tr
                  key={student.id}
                  className="border-t hover:bg-gray-50"
                >
                  {/* Name */}
                  <td className="px-2 py-1">
                    <div className="font-medium">
                      {student.firstName} {student.lastName}
                    </div>
                    <div className="text-gray-500 text-xs md:hidden">
                      {student.email}
                    </div>
                  </td>

                  {/* Email (desktop only) */}
                  <td className="px-2 py-1 hidden md:table-cell text-gray-600">
                    {student.email}
                  </td>

                  {/* Last sent */}
                  <td className="px-2 py-1 hidden md:table-cell text-gray-500">
                    {student.lastBookEmailSent
                      ? new Date(
                          student.lastBookEmailSent,
                        ).toLocaleDateString()
                      : 'Never'}
                  </td>

                  {/* Actions */}
                  <td className="px-2 py-1">
                    <div className="flex items-center gap-1 justify-end">
                      <div className="w-96">
                        <Select
                          isMulti
                          options={bookOptions}
                          placeholder="Books"
                          onChange={(opts) =>
                            handleStudentBookSelection(
                              student.id,
                              opts,
                            )
                          }
                          className="text-xs"
                        />
                      </div>

                      <button
                        onClick={() =>
                          handleNotifyStudent(student.id)
                        }
                        className="bg-green-600 text-white px-2 py-1 text-xs rounded hover:bg-green-700"
                      >
                        Send
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default TeacherClass;
